/**
 * Common request headers
 */
export const requiredHeaders = Object.freeze({
  Accept: 'application/json, text/plain, */*',
  'Content-Type': 'application/json',
});
